import * as React from "react";
import { CacheContext } from "../../../../../contexts/CacheContext";
import { DateFormats, IAvailabilitySchedule } from "intake_shared/src/types";
import { getDayTimeFromScheduleDate } from "../../../../../utils/utils";
import moment from "../../../../../utils/app_moment";
import { Button } from "../../../bits/Button/Button";
import { serviceDeliveryOptionLabels } from "intake_shared/src/constants";
import TrashIcon from "../../../icons/Trash";
import Table from "../../../bits/Table/Table";
import styles from "../HistoryWrapper.module.scss";
import EmptyListState from "../../../bits/EmptyListState/EmptyListState";

interface ReserveTimeProps {
    reservedWindows: IAvailabilitySchedule[];
    onRemoveSchedule: (schedule: IAvailabilitySchedule) => void;
}

export default function ReserveTime({
    reservedWindows,
    onRemoveSchedule,
}: ReserveTimeProps) {
    const olc = React.useContext(CacheContext);

    const columns = React.useMemo(() => {
        return [
            {
                Header: "Time",
                id: "reserved-time",
                accessor: (row: IAvailabilitySchedule) => {
                    const startStr = row?.start
                        ? getDayTimeFromScheduleDate(
                              row.start,
                              DateFormats.DAY_HOUR_FORMAT
                          )
                        : "--";
                    const endStr = row?.end
                        ? getDayTimeFromScheduleDate(row.end)
                        : "--";
                    return `${startStr} - ${endStr}`;
                },
            },
            {
                Header: "Recurrence",
                accessor: "recurrenceRule",
            },
            {
                Header: "Starting",
                id: "reserved-time-starting",
                accessor: (row: IAvailabilitySchedule) => {
                    const date = row?.starting_date || row?.start;
                    return date
                        ? `${moment(date).format(DateFormats.DATE_FORMAT)}`
                        : "--";
                },
            },
            {
                Header: "Reserved for",
                accessor: "reservedFor",
            },
            {
                Header: "Requested Service",
                accessor: (row) => {
                    return row?.availableService
                        ? (olc?.requestedServices || {})[row.availableService]
                        : "--";
                },
            },
            {
                Header: "In-Person or Telemed",
                accessor: (row: IAvailabilitySchedule) => {
                    return row?.serviceDeliveryOption
                        ? serviceDeliveryOptionLabels[row.serviceDeliveryOption]
                        : "--";
                },
            },
            {
                Header: "",
                id: "delete-reserved-window",
                accessor: (row: IAvailabilitySchedule) => (
                    <Button
                        variant="normal"
                        className={styles.deleteButton}
                        onClick={() => {
                            onRemoveSchedule(row);
                        }}
                    >
                        <TrashIcon />
                    </Button>
                ),
            },
        ];
    }, [olc?.requestedServices, onRemoveSchedule]);

    return (
        <>
            {reservedWindows && reservedWindows?.length > 0 ? (
                <Table
                    stickyLastColumn
                    columns={columns}
                    data={reservedWindows}
                    allowSelect={false}
                />
            ) : (
                <EmptyListState
                    emptyMessage="No reserved windows found"
                    stateHelperText="Reserved Windows will appear here"
                />
            )}
        </>
    );
}
